import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { SignOut } from 'modules/Account';
import { LogoLayout } from 'modules/Layout';
function action({ route, query }) {
    if (query.logoutId) {
    // console.log('logoutId', query.logoutId);
    // store.dispatch(Account.actions.signOutCallback(query.logoutId));
    }
    return {
        chunks: [
            'account'
        ],
        name: route.name,
        component: /*#__PURE__*/ _jsx(LogoLayout, {
            children: /*#__PURE__*/ _jsx(SignOut, {
                logoutId: query.logoutId
            })
        })
    };
}
export default action;
